import React, { PropsWithChildren, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import { useAppDispatch } from 'hooks/reduxHooks'
import { showSnackbar } from 'components/Luxkit/Snackbar/AppSnackbar'
import { EXPERIMENT, startExperiment } from 'lib/optimize'
import PromptCardSelector from 'components/Common/StickyPromptCard/PromptCardSelector'
import { GlobalSearchTrackingProvider } from 'contexts/GlobalSearch/GlobalSearchTracking'
import useHomepageAnalytics from 'home/pages/HomePage/useHomepageAnalytics'
import AnalyticsPageContext, { AnalyticsPage } from 'contexts/Analytics/analyticsPageContext'
import usePreloadTranslation from 'hooks/usePreloadTranslation'
import ErrorBoundary from 'components/Common/ErrorBoundary/ErrorBoundary'
import { OptimizelyServerSideExperiments } from 'lib/optimizely'
import { setOptimizelyExperiment } from 'actions/SystemActions'

const HOMEPAGE_VERSION = 'old-homepage'
interface MappedProps {
  utmMedium: string | undefined;
  currency: string;
}

function FrontPage(props: PropsWithChildren & MappedProps) {
  const { children, utmMedium, currency } = props
  const dispatch = useAppDispatch()
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    if (utmMedium !== 'cpc') {
      startExperiment(EXPERIMENT.HOME_PAGE_LOADED)
      startExperiment(EXPERIMENT.REVIEW_V3_PAGE_LOADED)
    }
  }, [utmMedium])

  useEffect(() => {
    startExperiment(EXPERIMENT.TRENDING_DESTINATION_BY_SALES)
    dispatch(setOptimizelyExperiment(OptimizelyServerSideExperiments.isNewHomePageTestEnabled))
    dispatch(setOptimizelyExperiment(OptimizelyServerSideExperiments.isAuNewHomePageTestEnabled))
  }, [dispatch])

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    if (queryParams.has('emailverified') && queryParams.get('emailverified')) {
      queryParams.delete('emailverified')
      history.replace({
        search: queryParams.toString(),
      })
      showSnackbar(
        'You will now receive the best offers in your inbox',
        'success',
        { heading: 'Congrats! Your email is verified' },
      )
    }
  }, [dispatch, history, location.search])

  const { onSearchEvent } = useHomepageAnalytics(HOMEPAGE_VERSION, currency)

  usePreloadTranslation('offerPage')

  return (
    <AnalyticsPageContext.Provider value={AnalyticsPage.homepageOld}>
      <div className="FrontPage">
        <ErrorBoundary fallback={null}>
          <PromptCardSelector abandonedCart hotLead tripReengagement />
        </ErrorBoundary>
        <GlobalSearchTrackingProvider onEvent={onSearchEvent}>
          {children}
        </GlobalSearchTrackingProvider>
      </div>
    </AnalyticsPageContext.Provider>
  )
}

function mapStateToProps(state: App.State) {
  return {
    utmMedium: state.utm.medium,
    currency: state.geo.currentCurrency,
  }
}

export default connect(mapStateToProps)(FrontPage)
